import axios from 'axios';

App.Recaptcha = {

    opt_widget_id: 0,

    recaptchaSelector: '.js--recaptcha',

    init: function(){

        document.querySelectorAll(this.recaptchaSelector+':not(._recaptcha-init)').forEach(el => {

            const widgetId = grecaptcha.render(el, {
                sitekey: G_RECAPTCHA_SITE_KEY,
                callback: function(token) { // Добавим callback
                    const form = el.closest('form');
                    App.Recaptcha.sendFormData(form); // Вызываем функцию отправки формы
                },
                size: 'invisible',
                'error-callback': function() {
                    console.error('reCAPTCHA error callback called!');
                }
            });

            // Сохраняем ID виджета в атрибуте data-widget-id
            el.dataset.widgetId = widgetId;

            el.classList.add('_recaptcha-init');

        });

    },

    execute: function (element) {
        console.log('execute');
        grecaptcha.execute(element);
    },

    sendFormData: function (form){
        console.log('callback');
        const formData = new FormData(form);

        axios.post(form.action, formData)
            .then((response) => {

                if(App.AjaxPreloader){
                    App.AjaxPreloader.stop();
                }

                form.classList.remove('_disabled');

                const data = response.data;

                form.querySelectorAll('.form-item').forEach((formItem) => {
                    formItem.classList.remove('_error');
                });

                switch (data.STATUS) {
                    case 'ERROR':

                        for (let key in data.ERRORS) {

                            let input = form.querySelector('[name="' + key + '"]');
                            if (!input) input = form.querySelector('[name="' + key + '[]"]');
                            if (input) {
                                const inputContainer = input.closest('.form-item'),
                                    errorText = inputContainer.querySelector('.form-item__error');
                                if (errorText) errorText.innerHTML = data.ERRORS[key];
                                inputContainer.classList.add('_error');
                            } else if (key === 'other') {
                                const errorText = form.querySelector('.js--form-other-error');
                                if (errorText) {
                                    errorText.innerHTML = data.ERRORS[key];
                                    errorText.classList.add('_error');
                                }
                            }

                        }

                        break;
                    case 'OK':

                        if (data.CALLBACK == "Y"){
                            // Создание заявки на обратный звонок
                            window.ctw.getRouteKeyData('newlife_ul', function(success, data){
                                console.log(success, data);
                                if (success) {
                                    if (data.widgetFound) {
                                        if (data.widgetData.callCenterWorkingMode == 'working_hours') {
                                            console.log('колл-центр работает, отображение виджета');
                                        } else {
                                            if (data.widgetData.collectNonWorkingRequests) {
                                                console.log('колл-центр не работает, но можем отобразить форму нерабочего времени');
                                            } else {
                                                console.log('колл-центр не работает, заявки в нерабочее время не собираем');
                                            }
                                        }
                                    } else {
                                        console.log('не найден включенный виджет по routeKey, либо услуга обратного звонка не активна');
                                    }
                                } else {
                                    console.log('во время обработки произошла ошибка');
                                    console.log(data)
                                }
                            });

                            window.ctw.createRequest(
                                'newlife_ul',
                                form.querySelector('[name="form_text_12"]').value.replace(/[^0-9]/g, ''),
                                [
                                    {"name": "FIO", "value": form.querySelector('[name="form_text_11"]').value},
                                ],
                                function(success, data){
                                    console.log(success, data)
                                    if (success) {
                                        console.log('Создана заявка на колбек, идентификатор: ' + data.callbackRequestId)
                                    } else {
                                        switch(data.type) {
                                            case "request_throttle_timeout":
                                            case "request_throttle_count":
                                                console.log('Достигнут лимит создания заявок, попробуйте позже');
                                                break;
                                            case "request_phone_blacklisted":
                                                console.log('номер телефона находится в черном списке');
                                                break;
                                            case "validation_error":
                                                console.log('были переданы некорректные данные');
                                                break;
                                            default:
                                                console.log('Во время выполнения запроса произошла ошибка: ' + data.type);
                                        }
                                    }
                                },
                                null,
                                [],
                                null,
                            )
                            // END Создание заявки на обратный звонок

                        }

                        form.querySelectorAll('[type=text], [type=tel], [type=email], textarea').forEach((input) => {
                            input.value = '';
                        });

                        App.Popup.openPopupSuccess({
                            title: data.SUCCESS_TITLE,
                            text: data.SUCCESS_TEXT
                        });

                        // Если нужна отправка в метрику
                        const seo = form.querySelector('[name="seo"]').value ?? false;
                        const seoCategory = form.querySelector('[name="seoCategory"]').value ?? false;
                        if(seo && seoCategory) {
                            App.Seo.send('formSend', seoCategory, seo, '');
                        }

                        break;
                }

                grecaptcha.reset()
            })
            .catch((error) => {
                if(App.AjaxPreloader){
                    App.AjaxPreloader.stop();
                }
                form.classList.remove('_disabled');
                console.log(error);
            });
    },

    update: function(el){

        if (!el) return;
        const ID = el.dataset.optWidgetId;
        if (!ID) return;
        grecaptcha.reset(Number(ID));

    }
}